import originalClassNames from "classnames";
import type { Argument } from "classnames";
import { twMerge } from "tailwind-merge";

export const classNames = (...args: Argument[]) =>
  twMerge(originalClassNames(args));
